import axios from 'axios';
import * as Config from '../../config';

const state = {
    stateApkVersion: null,
    statePaxVersion: false,
};

const actions = {
    apk_version_get_last_version({ commit, dispatch },form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'apk-version/get-last-version', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    updateStateApkVersion({ commit }, version) {
        commit('setStateApkVersion', version);
    },
    updateStatePaxVersion({ commit }, version) {
        commit('setStatePaxVersion', version);
    }
};

const getters = {
    stateApkVersion: state => state.stateApkVersion,
    statePaxVersion: state => state.statePaxVersion
}

const mutations = {
    setStateApkVersion(state, version) {
        state.stateApkVersion = version;
    },
    setStatePaxVersion(state, version) {
        state.statePaxVersion = version;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};